import { render, staticRenderFns } from "./MarkdownTitle.vue?vue&type=template&id=383e4b0c&scoped=true"
import script from "./MarkdownTitle.vue?vue&type=script&lang=js"
export * from "./MarkdownTitle.vue?vue&type=script&lang=js"
import style0 from "./MarkdownTitle.vue?vue&type=style&index=0&id=383e4b0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e4b0c",
  null
  
)

export default component.exports